import { Link } from "react-router-dom";
import { brand, footerGroups } from "@/mocks/site";
import SubscribeForm from "@/components/feature/SubscribeForm";

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-950 text-background-100">
      <div className="max-w-[1240px] mx-auto px-4 md:px-10 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5 mb-5">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-eye-off-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                {brand.name}
              </span>
            </div>
            <p className="text-sm leading-relaxed text-secondary-200 max-w-md">
              {brand.intro}
            </p>
            <div className="mt-6 space-y-2 text-sm">
              <p className="flex items-center gap-2 text-secondary-200">
                <i className="ri-mail-line text-accent-400" aria-hidden="true"></i>
                线索与合作：{brand.email}
              </p>
              <p className="flex items-center gap-2 text-secondary-200">
                <i className="ri-shield-star-line text-accent-400" aria-hidden="true"></i>
                {brand.established} ｜ {brand.promise}
              </p>
            </div>
          </div>

          {footerGroups.map((group) => (
            <nav key={group.title} className="lg:col-span-2" aria-label={group.title}>
              <h3 className="font-heading text-base font-semibold text-background-50 mb-4">
                {group.title}
              </h3>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-secondary-200 hover:text-accent-400 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}

          <div className="lg:col-span-3" id="subscribe">
            <h3 className="font-heading text-base font-semibold text-background-50 mb-4">
              订阅爆料更新
            </h3>
            <SubscribeForm />
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-secondary-300">
            © {new Date().getFullYear()} {brand.name}. 内容为公开现象归纳与方法分享，不构成法律意见。
          </p>
          <p className="text-xs text-secondary-300">
            {brand.slogan}
          </p>
        </div>
      </div>
    </footer>
  );
}